import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  USER, PROVIDERS
} from '../actions/auth.actions';

const INITIAL_STATE = {
  isAuthenticated: localStorage.getItem("token") ? true : false,
  isLoading: false,
  errorMessage: '',
  user: null,
  providers: null
};

const auth = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case PROVIDERS: {
      console.log(action.payload);
      return {
        ...state,
        providers: action.payload
      }
    }

    case USER: {
      console.log(action.payload);
      return {
        ...state,
        user: action.payload
      }
    }

    case LOGIN: {
      return {
        ...state,
        isLoading: true,
        errorMessage: ''
      };
    }

    case LOGIN_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        errorMessage: ''
      }
    }

    case LOGIN_FAIL: {
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload
      }
    }

    case LOGOUT: {
      return {
        ...state,
        isAuthenticated: false,
      }
    }

    default:
      return state;
  }
}

export default auth;
